import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { graphql } from 'react-apollo';
import IdeaMountainChart from 'components/IdeaMountainChart';
import IdeaBarChart from 'components/IdeaBarChart';
import { responseToProps, ChartDataQuery, ChartDataQueryVariables, Data } from './selectors';
import * as query from './query.gql';

import './index.scss';

export interface Props {
  ideaId: number;
  /** draw base line if there is no chart */
  baseLine?: boolean;
}

type Enhanced = Props & Data;

const enhance = compose<Enhanced, Props>(
  graphql<Props, ChartDataQuery, ChartDataQueryVariables, Data>(query, {
    props: responseToProps,
    options: ({ ideaId }) => ({
      variables: { id: ideaId },
      errorPolicy: 'all',
    }),
  })
);

const chartType: { [type in NonNullable<Data['chartData']>['__typename']]: 'bars' | 'mountain' } = {
  Investment_MountainChart: 'mountain',
  Investment_BarChart: 'bars',
};

const b = b_.with('idea-chart');

export class IdeaChart extends React.Component<Enhanced> {
  render() {
    const { chartData, baseLine } = this.props;
    return (
      <div className={b()}>
        <div
          className={b('base-line', {
            visible:
              chartData && chartData.data.length
                ? chartData.__typename === 'Investment_BarChart'
                : baseLine,
          })}
        />
        <div className={b('content', { type: chartData && chartType[chartData.__typename] })}>
          {this.renderChart()}
        </div>
      </div>
    );
  }

  private renderChart() {
    const { chartData } = this.props;

    if (!chartData) {
      return null;
    }

    switch (chartData.__typename) {
      case 'Investment_MountainChart':
        return <IdeaMountainChart data={chartData.data} width={960} />;

      case 'Investment_BarChart':
        return <IdeaBarChart data={chartData.data} width={500} />;
    }
  }
}

export default enhance(IdeaChart);
